import Layout from '~/views/layouts/Layout.vue'
import LayoutCenter from '~/views/layouts/LayoutCenter.vue'


export let MODULE_WORKSPACE = 'MODULE_WORKSPACE'
export let MODULE_SYSTEM = 'MODULE_SYSTEM'

const routers = {
    scrollBehavior: () => ({y: 0}),
    routes: [

        {
            path: '/404',
            name: "404",
            component: Layout,
            hidden: true,
            meta: {
                module: MODULE_WORKSPACE
            },
            children: [{
                path: '/404',
                meta: {
                    module: MODULE_WORKSPACE
                },
                components: require('~/views/pages/404.vue'),
            }]
        },

        {
            path: '/403',
            name: "403",
            component: Layout,
            hidden: true,
            meta: {
                module: MODULE_WORKSPACE
            },
            children: [{
                path: '/403',
                meta: {
                    module: MODULE_WORKSPACE
                },
                components: require('~/views/pages/403.vue'),
            }]
        },

        {path: '*', redirect: '/404', hidden: true},

        {
            path: '/',
            component: Layout,
            redirect: '/home/index',
            name: 'Dashboard',
            meta: {
                module: MODULE_WORKSPACE
            },
            hidden: true,
            children: [{
                path: 'dashboard',
                meta: {
                    module: MODULE_WORKSPACE
                },
                components: require('~/views/home/index.vue'),
            }]
        },


        {
            path: '/home',
            component: Layout,
            redirect: '/home/index',
            //name: '仪表盘',
            meta: {
                title: '工作台',
                icon: 'el-icon-fa-dashboard',
                module: MODULE_WORKSPACE
            },
            children: [
                {
                    path: 'index',
                    components: require('~/views/home/index.vue'),
                    name: '首页',
                    meta: {
                        title: '首页',
                        icon: 'el-icon-fa-home'
                    }
                },
                {
                    path: 'customer',
                    components: require('~/views/customer/my-customer.vue'),
                    hidden:true,
                    name: '首页-客户列表',
                    meta: {
                        title: '客户列表',
                        icon: 'el-icon-fa-users'
                    }
                },
                {
                    path: 'lead',
                    components: require('~/views/clue/index.vue'),
                    hidden:true,
                    name: '首页-线索列表',
                    meta: {
                        title: '线索列表',
                        icon: 'el-icon-fa-diamond'
                    }
                },
                {
                    path: 'my-lead',
                    components: require('~/views/clue/myclue.vue'),
                    hidden:true,
                    name: '首页-我的线索',
                    meta: {
                        title: '我的线索',
                        icon: 'el-icon-fa-star'
                    }
                },
                {
                    path: 'expire-order',
                    components: require('~/views/order/list.vue'),
                    hidden:true,
                    name: '首页-过期订单',
                    meta: {
                        title: '线索列表',
                        icon: 'el-icon-fa-diamond'
                    }
                },
            ]
        },
        //登录页
        {
            path: '/login',
            component: LayoutCenter,
            redirect: '/pages',
            name: '登录',
            hidden: true,
            children: [{
                path: '/login',
                components: require('~/views/pages/login.vue'),
            }]
        },
        //统计分析
        {
            path: '/count',
            component: Layout,
            redirect: '/count/collect',
            name: '统计分析',
            meta: {
                module: MODULE_WORKSPACE,
                title: '统计分析',
                icon: 'el-icon-s-data'
            },
            children: [
                {
                    path: 'collect',
                    components: require('~/views/count/collect.vue'),
                    name: '数据总览',
                    meta: {
                        title: '数据总览',
                        icon: 'el-icon-fa-list'
                    }
                },
                {
                    path: 'payorder',
                    components: require('~/views/count/payorder.vue'),
                    name: '销售结果',
                    meta: {
                        title: '销售结果',
                        icon: 'el-icon-fa-list'
                    }
                },
                {
                    path: 'clueanalysis',
                    components: require('~/views/count/clueanalysis.vue'),
                    name: '线索分析',
                    meta: {
                        title: '线索分析',
                        icon: 'el-icon-fa-list'
                    }
                },
                {
                    path: 'customeranalysis',
                    components: require('~/views/count/customeranalysis.vue'),
                    name: '客户分析',
                    meta: {
                        title: '客户分析',
                        icon: 'el-icon-fa-list'
                    }
                },
                {
                    path: 'saleanalysis',
                    components: require('~/views/count/saleanalysis.vue'),
                    name: '销售管理分析',
                    meta: {
                        title: '销售管理分析',
                        icon: 'el-icon-fa-list'
                    }
                },
                {
                    path: 'payment',
                    components: require('~/views/count/payment.vue'),
                    name: '回款管理分析',
                    meta: {
                        title: '回款管理分析',
                        icon: 'el-icon-fa-list'
                    }
                },
                {
                    path: 'performancecalc',
                    components: require('~/views/count/performancecalc.vue'),
                    name: '业绩汇算',
                    meta: {
                        title: '业绩汇算',
                        icon: 'el-icon-fa-list'
                    }
                },
            ]
        },
        {
            path: '/tasks',
            component: Layout,
            redirect: '/tasks/index',
            //name: '仪表盘',
            meta: {
                title: '工作台',
                icon: 'dashboard',
                module: MODULE_WORKSPACE
            },
            children: [{
                path: 'index',
                components: require('~/views/tasks/index.vue'),
                name: '我的任务',
                meta: {
                    title: '我的任务',
                    icon: 'el-icon-fa-tasks'
                }
            }]
        },

        {
            path: '/order',
            component: Layout,
            redirect: '/order/index',
            name: '审批管理',
            meta: {
                title: '审批管理',
                icon: 'el-icon-fa-check-square',
                module: MODULE_WORKSPACE
            },
            children: [
                {
                    path: 'approve',
                    components: require('~/views/order/business.vue'),
                    name: 'approve',
                    meta: {
                        title: '我的审批',
                        icon: 'el-icon-fa-check-square'
                    }
                },
                {
                    path: 'audit-log',
                    components: require('~/views/order/approve/auditLog.vue'),
                    name: 'audit-log',
                    meta: {
                        title: '审批异常管理',
                        icon: 'el-icon-fa-exclamation-circle'
                    }
                },
            ]
        },

        //线索管理
        {
            path: '/sales-leads',
            component: Layout,
            redirect: '/sales-leads/my-index',
            name: '销售线索',
            meta: {
                module: MODULE_WORKSPACE,
                title: '销售线索',
                icon: 'el-icon-fa-diamond'
            },
            children: [
                {
                    path: 'create',
                    components: require('~/views/clue/create.vue'),
                    name: '新增线索',
                    hidden: true,
                    meta: {
                        title: '新增线索',
                        icon: 'el-icon-fa-plus-square'
                    }
                },

                {
                    path: 'update',
                    components: require('~/views/clue/edit.vue'),
                    name: '线索编辑',
                    hidden: true,
                    meta: {
                        title: '线索编辑',
                    }
                },
                {
                    path: 'view',
                    components: require('~/views/clue/view.vue'),
                    name: '线索详情',
                    hidden: true,
                    meta: {
                        title: '线索详情',
                    }
                },
                {
                    path: 'allocation',
                    components: require('~/views/clue/allocation.vue'),
                    name: '线索分配',
                    meta: {
                        title: '线索分配',
                        icon: 'el-icon-fa-list'
                    }
                },
                {
                    path: "public-list",
                    components: require('~/views/clue/PublicList.vue'),
                    name: '公共线索',
                    meta: {
                        title: '公共线索',
                        icon: 'el-icon-fa-cloud'
                    }
                },

                {
                    path: 'index',
                    components: require('~/views/clue/index.vue'),
                    name: '全部线索',
                    meta: {
                        title: '全部线索',
                        icon: 'el-icon-fa-list'
                    }
                },

                {
                    path: 'my-index',
                    components: require('~/views/clue/myclue.vue'),
                    name: '我的线索',
                    meta: {
                        title: '我的线索',
                        icon: 'el-icon-fa-star'
                    }
                },
                {
                    path: 'channel',
                    components: require('~/views/clue/channel.vue'),
                    name: '线索渠道管理',
                    meta: {
                        title: '线索渠道管理',
                        icon: 'el-icon-fa-list'
                    }
                },
                {
                    path: 'share-manage',
                    components: require('~/views/clue/ShareManage.vue'),
                    name: '活动分享管理',
                    meta: {
                        title: '活动分享管理',
                        icon: 'el-icon-fa-list'
                    }
                },
                {
                    path: 'logs',
                    components: require('~/views/clue/logs.vue'),
                    name: '线索操作日志',
                    meta: {
                        title: '线索操作日志',
                        icon: 'el-icon-fa-list'
                    }
                }
            ]
        },

        //客户管理
        {
            path: '/customers',
            component: Layout,
            redirect: '/customers/index',
            name: '客户管理',
            meta: {
                module: MODULE_WORKSPACE,
                title: '客户管理',
                icon: 'el-icon-fa-users'
            },
            children: [
                {
                    path: 'create',
                    components: require('~/views/customer/create.vue'),
                    name: '新增客户',
                    hidden: true,
                    meta: {
                        title: '新增客户',
                        icon: 'el-icon-fa-plus-square'
                    }
                },
                {
                    path: 'update',
                    components: require('~/views/customer/update.vue'),
                    name: '客户编辑',
                    hidden: true,
                    meta: {
                        title: '客户编辑',
                    }
                },
                {
                    path: 'my-update',
                    components: require('~/views/customer/update.vue'),
                    name: '编辑我的客户',
                    hidden: true,
                    meta: {
                        title: '编辑我的客户',
                    }
                },
                {
                    path: 'view',
                    components: require('~/views/customer/view.vue'),
                    name: '客户详情',
                    hidden: true,
                    meta: {
                        title: '客户详情',
                    }
                },
                {
                    path: 'high-value',
                    components: require('~/views/customer/high-value.vue'),
                    name: '高价值客户推荐',
                    meta: {
                        title: '高价值客户推荐',
                        icon: 'el-icon-fa-star',
                        menuClass: 'menu-high-value',
                        auth: '/high-value-customers/index'
                    }
                },
                {
                    path: 'insight',
                    components: require('~/views/customer/insight.vue'),
                    name: '智能客户洞察',
                    hidden: true,
                    meta: {
                        title: '智能客户洞察',
                        auth: '/high-value-customers/view'
                    }
                },
                {
                    path: 'my-index',
                    components: require('~/views/customer/my-customer.vue'),
                    name: '我的客户',
                    meta: {
                        title: '我的客户',
                        icon: 'el-icon-fa-heart'
                    }
                },
                {
                    path: 'done',
                    components: require('~/views/customer/done.vue'),
                    name: '成交客户查询',
                    meta: {
                        title: '成交客户',
                        icon: 'el-icon-fa-usd'
                    }
                },
                {
                    path: 'public',
                    components: require('~/views/customer/index.vue'),
                    name: '客户公海池',
                    meta: {
                        title: '客户公海池',
                        icon: 'el-icon-fa-cloud'
                    }
                },
                {
                    path: 'index',
                    components: require('~/views/customer/index.vue'),
                    name: '全部客户',
                    meta: {
                        title: '全部客户',
                        icon: 'el-icon-fa-list'
                    }
                },
                {
                    path: 'visits',
                    components: require('~/views/customer/VisitCustomers.vue'),
                    name: '回访客户',
                    meta: {
                        title: '全部回访客户',
                        icon: 'el-icon-fa-volume-control-phone'
                    }
                },
                {
                    path: 'my-visits',
                    components: require('~/views/customer/VisitCustomers.vue'),
                    name: '我的回访客户',
                    meta: {
                        title: '我的回访客户',
                        icon: 'el-icon-fa-headphones'
                    }
                },
                {
                    path: 'trance-log',
                    components: require('~/views/customer/tranceLog.vue'),
                    name: '客户跟进日志',
                    meta: {
                        title: '客户跟进日志',
                        icon: 'el-icon-fa-file-text-o'
                    }
                },
                {
                    path: 'disruption-product',
                    components: require('~/views/customer/DisruptionProduct.vue'),
                    name: '断续产品管理',
                    meta: {
                        title: '断续产品管理',
                        icon: 'el-icon-fa-list'
                    }
                },
                {
                    path: 'refund-product',
                    components: require('~/views/customer/refundProduct.vue'),
                    name: '退款产品记录',
                    meta: {
                        title: '退款产品记录',
                        icon: 'el-icon-fa-list'
                    }
                },
                {
                    path: 'download-count',
                    components: require('~/views/customer/downloadCount.vue'),
                    name: '客户资源使用',
                    meta: {
                        title: '客户资源使用',
                        icon: 'el-icon-fa-list'
                    }
                },
                {
                    path: 'query-info',
                    components: require('~/views/customer/queryInfo.vue'),
                    name: '客户合作查询',
                    meta: {
                        title: '客户合作查询',
                        icon: 'el-icon-zoom-in'
                    }
                },
                {
                    path: 'import-order',
                    components: require('~/views/customer/importOrder.vue'),
                    name: '订单导入记录',
                    meta: {
                        title: '订单导入记录',
                        icon: 'el-icon-fa-list'
                    }
                }
            ]
        },
        //订单管理
        {
            path: '/order',
            component: Layout,
            redirect: '/order/index',
            name: '订单管理',
            meta: {
                module: MODULE_WORKSPACE,
                title: '订单管理',
                icon: 'el-icon-fa-balance-scale'
            },
            children: [
                {
                    path: 'create',
                    components: require('~/views/order/form.vue'),
                    name: '新增订单',
                    hidden: true,
                    meta: {
                        title: '新增订单',
                        icon: 'el-icon-fa-plus-square'
                    }
                },
                {
                    path: 'edit',
                    components: require('~/views/order/form.vue'),
                    name: '订单编辑',
                    hidden: true,
                    meta: {
                        title: '订单编辑',
                    },
                },
                {
                    path: 'renew',
                    components: require('~/views/order/form.vue'),
                    name: '订单续约',
                    hidden: true,
                    meta: {
                        title: '订单续约',
                    },
                },
                {
                    path: 'revise',
                    components: require('~/views/order/form.vue'),
                    name: '订单修订',
                    hidden: true,
                    meta: {
                        title: '订单修订',
                    },
                },
                {
                    path: 'refund',
                    components: require('~/views/order/form.vue'),
                    name: '订单退款',
                    hidden: true,
                    meta: {
                        title: '订单退款',
                    },
                },
                {
                    path: 'index',
                    components: require('~/views/order/list.vue'),
                    name: '全部订单',
                    meta: {
                        title: '全部订单',
                        icon: 'el-icon-fa-list'
                    }
                },
                {
                    path: 'my-order',
                    components: require('~/views/order/list.vue'),
                    name: '我的订单',
                    meta: {
                        title: '我的订单',
                        icon: 'el-icon-fa-list'
                    }
                }, 
                {
                    path: 'invoice',
                    components: require('~/views/order/invoice.vue'),
                    name: '全部发票',
                    meta: {
                        title: '全部发票',
                        icon: 'el-icon-fa-list-alt'
                    }
                },
                {
                    path: 'my-invoice',
                    components: require('~/views/order/invoice.vue'),
                    name: '我的发票',
                    meta: {
                        title: '我的发票',
                        icon: 'el-icon-fa-list-alt'
                    }
                },
                {
                    path: 'view',
                    components: require('~/views/order/view.vue'),
                    name: '订单详情',
                    hidden: true,
                    meta: {
                        title: '订单详情',
                        icon: 'table'
                    }
                },
                {
                    path: 'contract-seal',
                    components: require('~/views/order/contractSeal.vue'),
                    name: '全部合同盖章',
                    meta: {
                        title: '全部合同盖章',
                        icon: 'el-icon-fa-list'
                    }
                },
                {
                    path: 'my-contract-seal',
                    components: require('~/views/order/contractSeal.vue'),
                    name: '我的合同盖章',
                    meta: {
                        title: '我的合同盖章',
                        icon: 'el-icon-fa-list'
                    }
                },
                {
                    path: 'logistics',
                    components: require('~/views/order/logistics.vue'),
                    name: '全部快递',
                    meta: {
                        title: '全部快递',
                        icon: 'el-icon-fa-list'
                    }
                },
                {
                    path: 'my-logistics',
                    components: require('~/views/order/logistics.vue'),
                    name: '我的快递',
                    meta: {
                        title: '我的快递',
                        icon: 'el-icon-fa-list'
                    }
                }]
        },
        {
            path: '/order',
            component: Layout,
            redirect: '/order/payment',
            name: '回款管理',
            meta: {
                module: MODULE_WORKSPACE,
                title: '回款管理',
                icon: 'el-icon-goods'
            },
            children:[
                {
                    path: 'payment',
                    components: require('~/views/pay/list.vue'),
                    name: '全部回款',
                    meta: {
                        title: '全部回款',
                        icon: 'el-icon-menu'
                    }
                },
                {
                    path: 'my-payment',
                    components: require('~/views/pay/list.vue'),
                    name: 'my-pay',
                    meta: {
                        title: '我的回款',
                        icon: 'el-icon-menu'
                    }
                },
            ]
        },
        {
            path: '/finance',
            component: Layout,
            redirect: '/finance/income',
            name: '财务管理',
            meta: {
                module: MODULE_WORKSPACE,
                title: '财务管理',
                icon: 'el-icon-s-finance'
            },
            children:[
                {
                    path: 'income',
                    components: require('~/views/finance/income.vue'),
                    name: '收入确认',
                    meta: {
                        title: '收入确认',
                        icon: 'el-icon-fa-list'
                    }
                },
            ]
        },
        // 用户管理
        {
            path: '/users',
            component: Layout,
            redirect: '/users/index',
            name: '用户管理',
            meta: {
                title: '用户管理',
                icon: 'el-icon-fa-users',
                module: MODULE_SYSTEM
            },
            children: [{
                path: 'create',
                components: require('~/views/user/create.vue'),
                name: '新增用户',
                hidden: true,
                meta: {
                    title: '新增用户',
                    icon: 'el-icon-fa-plus-square'
                }
            }, {
                path: 'view',
                components: require('~/views/user/view.vue'),
                name: '用户详情',
                hidden: true,
                meta: {
                    title: '用户详情',
                    module: MODULE_SYSTEM
                }
            }, {
                path: 'update',
                components: require('~/views/user/update.vue'),
                name: '用户编辑',
                hidden: true,
                meta: {
                    title: '用户编辑',
                }
            }, {
                path: 'index',
                components: require('~/views/user/index.vue'),
                name: '用户列表',
                hidden: false,
                meta: {
                    title: '用户列表',
                    icon: 'el-icon-fa-list',
                }
            }, {
                path: 'areas',
                components: require('~/views/user/areas.vue'),
                name: '区域绑定',
                hidden: true,
                meta: {
                    title: '区域绑定',
                    icon: 'el-icon-fa-list',
                }
            }, {
                path: 'change-pwd',
                components: require('~/views/user/changePwd.vue'),
                name: '修改密码',
                hidden: true,
                meta: {
                    title: '修改密码',
                    icon: MODULE_SYSTEM,
                }
            }, {
                path: 'area-group',
                components: require('~/views/user/areaGroup.vue'),
                name: '区域用户组',
                hidden: false,
                meta: {
                    title: '区域用户组',
                    icon: 'el-icon-map-location',
                }
            }, {
                path: 'source-group',
                components: require('~/views/user/sourceGroup.vue'),
                name: '来源用户组',
                hidden: false,
                meta: {
                    title: '来源用户组',
                    icon: 'el-icon-notebook-2',
                }
            }, {
                path: 'area-user',
                components: require('~/views/user/AreaUser.vue'),
                name: '个人绑定区域',
                hidden: false,
                meta: {
                    title: '个人绑定区域',
                    icon: 'el-icon-location',
                }
            }]
        },
        //产品日志
        {
            path: '/log',
            component: Layout,
            redirect: '/log/xwt',
            name: '产品日志',
            meta: {
                module: MODULE_WORKSPACE,
                title: '产品日志',
                icon: 'el-icon-fa-history'
            },
            children: [
                {
                    path: 'xwt',
                    components: require('~/views/log/xwt.vue'),
                    name: '校网通|校本3',
                    meta: {
                        title: '校网通|校本3',
                        icon: 'el-icon-fa-list'
                    }
                },
                {
                    path: 'zj',
                    components: require('~/views/log/zj.vue'),
                    name: '组卷',
                    meta: {
                        title: '组卷',
                        icon: 'el-icon-fa-list-alt'
                    }
                }, {
                    path: 'jb',
                    components: require('~/views/log/jb.vue'),
                    name: '校本资源库',
                    meta: {
                        title: '校本资源库',
                        icon: 'el-icon-fa-list-alt'
                    }

                },
                {
                    path: 'jb3',
                    components: require('~/views/log/jb3.vue'),
                    name: '校本3资源库',
                    meta: {
                        title: '校本3资源库',
                        icon: 'el-icon-fa-list-alt'
                    }
                }
                ]
        },
        //联系人管理
        {
            path: '/contacts',
            component: Layout,
            redirect: '/contacts/index',
            name: '联系人管理',
            meta: {
                module: MODULE_WORKSPACE,
                title: '联系人管理',
                icon: 'el-icon-fa-address-book'
            },
            children: [
                {
                    path: 'my-index',
                    components: require('~/views/contact/mycontact.vue'),
                    name: '我的联系人',
                    meta: {
                        title: '我的联系人',
                        icon: 'el-icon-fa-address-book'
                    }
                },
                {
                    path: 'index',
                    components: require('~/views/contact/index.vue'),
                    name: '全部联系人',
                    meta: {
                        title: '全部联系人',
                        icon: 'el-icon-fa-users'
                    }
                },
            ]
        },
        //产品列表
        {
            path: '/products',
            component: Layout,
            redirect: '/products/index',
            name: '产品管理',
            meta: {
                module: MODULE_WORKSPACE,
                title: '产品管理',
                icon: 'el-icon-fa-flushed'
            },
            children: [{
                path: 'index',
                components: require('~/views/product/index.vue'),
                name: '产品列表',
                meta: {
                    title: '产品列表',
                    icon: 'el-icon-fa-product-hunt'
                }
            }]

        },
        //客户库管理
        {
            path: '/customer-std',
            component: Layout,
            redirect: '/customer-std/index',
            name: '客户库管理',
            meta: {
                module: MODULE_WORKSPACE,
                title: '客户库管理',
                icon: 'el-icon-s-custom'
            },
            children: [
                {
                    path: 'index',
                    components: require('~/views/customer-std/index.vue'),
                    name: '标准客户库',
                    meta: {
                        title: '标准客户库',
                        icon: 'el-icon-fa-list'
                    }
                },
                {
                    path: 'corp-list',
                    components: require('~/views/customer-std/corp-list.vue'),
                    name: '集团校管理',
                    meta: {
                        title: '集团校管理',
                        icon: 'el-icon-s-management'
                    }
                },
                {
                    path: 'create',
                    components: require('~/views/customer-std/create.vue'),
                    name: '标准库新增客户',
                    hidden: true,
                    meta: {
                        title: '标准库新增客户',
                        icon: 'el-icon-fa-plus-square'
                    }
                },
                {
                    path: 'update',
                    components: require('~/views/customer-std/update.vue'),
                    name: '标准库客户编辑',
                    hidden: true,
                    meta: {
                        title: '标准库客户编辑',
                    }
                },
            ]

        },
        //公有账号管理
        {
            path: '/public_acc',
            component: Layout,
            redirect: '/public_acc/list',
            name: '公有账号管理',
            meta: {
                module: MODULE_WORKSPACE,
                title: '公有账号管理',
                icon: 'el-icon-s-custom'
            },
            children: [
                {
                    path: 'list',
                    components: require('~/views/public_acc/list.vue'),
                    name: '公有账号列表',
                    meta: {
                        title: '公有账号列表',
                        icon: 'el-icon-fa-list'
                    }
                },
            ]
        },
        //知识库
        {
            path: '/knowledge-base',
            component: Layout,
            redirect: '/knowledge-base/rule-list',
            name: '知识库',
            meta: {
                module: MODULE_WORKSPACE,
                title: '知识库',
                icon: 'el-icon-s-custom'
            },
            children: [
                {
                    path: 'rule-list',
                    components: require('~/views/knowledge-base/rule-list.vue'),
                    name: '常用规则',
                    meta: {
                        title: '常用规则',
                        icon: 'el-icon-fa-list'
                    }
                },
            ]

        },
        // 组织架构
        {
            path: '/rbac',
            component: Layout,
            redirect: '/rbac/branches',
            name: '组织架构',
            meta: {
                module: MODULE_SYSTEM,
                title: '组织架构',
                icon: 'el-icon-fa-sitemap'
            },
            children: [{
                path: 'branches/index',
                components: require('~/views/branch/index.vue'),
                name: '部门管理',
                meta: {
                    title: '部门管理',
                    icon: 'el-icon-fa-codepen'
                }
            }, {
                path: 'permissions/index',
                components: require('~/views/permission/index.vue'),
                name: '权限管理',
                meta: {
                    title: '权限管理',
                    icon: 'el-icon-fa-lock'
                }
            }, {
                path: 'roles/index',
                components: require('~/views/roles/index.vue'),
                name: '职位管理',
                meta: {
                    title: '职位管理',
                    icon: 'el-icon-fa-user-circle'
                }
            }]
        },
        //流程管理
        {
            path: '/flow',
            component: Layout,
            redirect: '/flow/list',
            name: '流程管理',
            meta: {
                module: MODULE_SYSTEM,
                title: '审批管理',
                icon: 'el-icon-fa-filter'
            },
            children: [{
                path: 'index',
                components: require('~/views/flow/index.vue'),
                name: '审批流程管理',
                meta: {
                    title: '审批流程管理',
                    icon: 'el-icon-fa-link'
                }
            }, {
                path: 'order',
                components: require('~/views/flow/order.vue'),
                name: '订单流程配置',
                meta: {
                    title: '订单流程配置',
                    icon: 'el-icon-fa-cog'
                }
            }]
        },
        //系统日志
        {
            path: '/syslog',
            component: Layout,
            redirect: '/syslog/list',
            name: '系统日志',
            meta: {
                title: '系统日志',
                icon: 'peoples',
                module: MODULE_SYSTEM
            },
            children: [{
                path: 'list',
                components: require('~/views/syslog/list.vue'),
                name: '操作日志',
                meta: {
                    title: '操作日志',
                    icon: 'el-icon-fa-file-text-o'
                }
            }]
        },

        {
            path: '/message',
            component: Layout,
            redirect: '/message/index',
            name: '系统消息',
            meta: {
                title: '系统消息',
                icon: 'message',
                module: MODULE_WORKSPACE
            },
            hidden: true,
            children: [{
                path: 'index',
                components: require('~/views/message/index.vue'),
                name: '消息列表',
                meta: {
                    title: '系统消息',
                }
            }]
        },

        {
            path: '/district',
            component: Layout,
            redirect: '/district/index',
            name: '地区管理',
            meta: {
                title: '地区管理',
                icon: 'el-icon-fa-global',
                module: MODULE_SYSTEM
            },
            children: [{
                path: 'index',
                components: require('~/views/district/index.vue'),
                name: '地区列表',
                hidden: false,
                meta: {
                    title: '地区列表',
                    icon: 'el-icon-fa-map-marker',
                }
            }]
        },

        {
            path: '/login-rules',
            component: Layout,
            redirect: '/login-rules/rule-index',
            name: '规则设置',
            meta: {
                title: '规则设置',
                icon: 'el-icon-fa-fire',
                module: MODULE_SYSTEM
            },
            children: [{
                path: 'index',
                components: require('~/views/login-rules/index.vue'),
                name: '限制登录',
                hidden: false,
                meta: {
                    title: '限制登录',
                    icon: 'el-icon-fa-list'
                }
            }, {
                path: 'rule-index',
                components: require('~/views/login-rules/rule.vue'),
                name: '解绑规则',
                hidden: false,
                meta: {
                    title: '解绑规则',
                    icon: 'el-icon-fa-plus-square'
                }
            },
            {
                path: 'create',
                components: require('~/views/login-rules/create.vue'),
                name: '新增限制规则',
                hidden: true,
                meta: {
                    title: '新增限制规则',
                    icon: 'el-icon-fa-plus-square'
                }
            },{
                    path: 'update',
                    components: require('~/views/login-rules/update.vue'),
                    name: '编辑限制规则',
                    hidden: true,
                    meta: {
                        title: '编辑限制规则',
                        icon: 'el-icon-fa-plus-square'
                    }
                },{
                    path: 'rule-view',
                    components: require('~/views/login-rules/ruleUpdate.vue'),
                    name: '编辑规则',
                    hidden: true,
                    meta: {
                        title: '编辑规则',
                        icon: 'el-icon-fa-plus-square'
                    }
                },{
                    path: 'rule-look-logs',
                    components: require('~/views/login-rules/lookLogs.vue'),
                    name: '查看操作日志',
                    hidden: true,
                    meta: {
                        title: '查看操作日志',
                        icon: 'el-icon-fa-plus-square'
                    }
                }]
        },
    ]

}

export default routers



// WEBPACK FOOTER //
// ./src/config/routers.js